module.exports = "<span class=\"camera-info-label\">Attach documents</span>\n<div class=\"documents-container\"\n    *ngIf=\"!disabled\"\n    droppable\n    (onDrop)=\"attachDocument($event)\">\n    <app-camera-attached-document-item\n        *ngFor=\"let d of documents\"\n        [file]=\"d\"\n        (delete)=\"onRemoveFile($event)\">\n    </app-camera-attached-document-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/camera-documents-attacher/camera-documents-attacher.component.html
// module id = ./src/app/shared/components/camera-documents-attacher/camera-documents-attacher.component.html
// module chunks = main